import React from 'react';
import PropTypes from 'prop-types';
import Anchor from '../../../../../dashboardNew/objects/Anchor';

export const CategoryItem = (props) => {
    const {
        id,
        name,
    } = props.category;

    return (
        <div className="col-12 col-md-4 base-card webinar-card" >
            <Anchor path={`/forums/${id}/threads`} anchorClass="card-inner" internal>
                <div className="image" style={{ backgroundImage: `url(${props.cardProps.img})` }}></div>
                <div className="theme-webinar-body">
                    <h3 className="heading-three">{name}</h3>
                </div>
            </Anchor>
        </div>
    );
};

CategoryItem.propTypes = {
    category: PropTypes.object
}



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/CategoryItem.js